import React, {Component} from 'react';

import {AppContext} from '../../../AppModule/Context';
import {withWidgetContext} from '../widgetContextProvider';

import MentorsDirectoryComponent from '../../../screens/mentorsDirectoryScreen/mentorsDirectoryComponent';
import MultiExpertAgentsListWithHeaderComponent from './multiExpertAgentsListWithHeaderComponent';
import SingleExpertWidget from '../SingleExpertWidget/SingleExpertWidget';

import {ListeningRoomService} from '../../../services/websocketService';
import multiWidgetService from '../../../services/multiWidgetService';
// import postMessageService from '../../../services/postMessageService';
import utilsService from '../../../services/utilsService';
// import WidgetService from '../../../services/restServices/widgetService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './openMultiWidgetComponent.css';

class OpenMultiWidgetComponent extends Component {
  constructor() {
    super();
    this.state = {
      showSingleWidget: false,
    };
  }
  componentDidMount = () => {
    if (this.props.isInPersonalPage) {
      this.handlePersonalPageInit();
    } else if (this.props.isSingleWidget) {
      this.handleSingleWidgetInit();
    } else {
      this.handleMultiWidgetInit();
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    //when widgetDto is changed in backoffice side in demo mode
    if (
      this.props.isDemo &&
      JSON.stringify(prevProps.widgetDto) !==
        JSON.stringify(this.props.widgetDto)
    ) {
      if (this.props.isSingleWidget) {
        this.handleSingleWidgetInit();
      } else if (this.props.isMultiWidget) {
        this.handleMultiWidgetInit();
      }
    }

    /**
     *  multi expert widget case ->  buttons/action click
     */
    if (
      !this.state.showSingleWidget &&
      this.props.openSingleWidgetByPeerId &&
      prevProps.openSingleWidgetByPeerId !== this.props.openSingleWidgetByPeerId
    ) {
      if (this.props.isSingleWidget) {
        this.handleSingleWidgetInit();
      } else if (this.props.isMultiWidget) {
        this.handleMultiWidgetInit();
      }
    }

    /**
     *  Switch mentor when widget is already open
     */
    if (
      this.state.showSingleWidget &&
      this.props.openSingleWidgetByPeerId &&
      prevProps.openSingleWidgetByPeerId !== this.props.openSingleWidgetByPeerId
    ) {
      this.openCloseSpecificWidgetV2(this.props.openSingleWidgetByPeerId);
    }
    //todo widget : is this cases required?
    /**
     * In case:
     *  if widget mode is Single expert and external button clicked to open the account widget
     */
    // if (
    //   this.props.widgetMode ===
    //     VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE &&
    //   prevProps.actionClickData !== this.props.actionClickData &&
    //   this.props.actionClickData?.etAgentId === 'multi'
    // ) {
    //   this.props.resetOpenSingleWidgetByPeerIdAndActionClickData(() => {
    //     // Reset showSingleWidget state
    //     this.setState({showSingleWidget: false});
    //     this.props.setIsSingleWidgetMounted(false);
    //   });
    // }

    //todo widget : is this cases required?
    /**
     * In case:
     *  if widget mode is Single Expert and external button is clicked to open again Single expert widget
     */
    // if (
    //   this.props.widgetMode ===
    //     VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE &&
    //   prevProps.actionClickData?.etAgentId !==
    //     this.props.actionClickData?.etAgentId &&
    //   this.props.actionClickData?.etAgentId !== 'multi'
    // ) {
    //   // Reset showSingleWidget state
    //   this.setState({showSingleWidget: false});
    //   this.props.setIsSingleWidgetMounted(false);
    // }
    if (
      !this.props.isInPersonalPage &&
      this.props.widgetDto?.mentorsControlMapDto &&
      this.state.showSingleWidget !== undefined &&
      this.state.showSingleWidget !== prevState.showSingleWidget
    ) {
      this.sendWidgetOpenCloseStatus(this.state.showSingleWidget);
    }
    if (
      prevProps.widgetMode !== this.props.widgetMode &&
      this.props.widgetMode
    ) {
      if (
        prevProps.widgetMode ===
        VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE
      ) {
        this.setState({removeAgentListFadeAnim: true});
      } else {
        this.setState({removeAgentListFadeAnim: false});
      }
    }
  };
  componentWillUnmount = () => {
    // if (
    //   this.props.widgetDto.widgetAppCtrlDto.availabilityFilter !==
    //   VIDABOO_CONSTANTS.AVAILABILITY_STATES.OFFLINE.toUpperCase()
    // )
    //   postMessageService.setNumOfWidgets(0); // preparing for next open
  };

  handlePersonalPageInit = () => {
    if (this.props.profileName) {
      const mentorId = multiWidgetService.getMentorIdUsingProfileName(
        this.props.profileName,
        this.props.widgetDto.mentorsControlMapDto,
      );
      if (mentorId) {
        this.setState({
          selectedExMentorDto:
            this.props.widgetDto.mentorsControlMapDto[mentorId]
              .extendedMentorDto,
          showSingleWidget: true,
        });
      } else {
        console.error(
          'Consolto Widget: tried to open mentor with a wrong mentorId. Please make sure you provided the right mentorId and mentor is active.',
        );
        this.props.setNotificationPopUpData(
          'Seems there is no one here. Make sure the link is right.',
        );
      }
    }
  };

  handleSingleWidgetInit = () => {
    if (this.props.openSingleWidgetByPeerId) {
      this.openCloseSpecificWidgetV2(this.props.openSingleWidgetByPeerId);
    } else {
      if (this.props.inTeamChatScenario) {
        const ownerObjectId = multiWidgetService.getWidgetTeamMentorIds(
          this.props.widgetDto,
        )[0];
        this.openCloseSpecificWidgetV2(ownerObjectId);
      } else if (this.props.canMoveToTeamChat) {
        const selectedMentorId =
          utilsService.getTeamOneOnOneRoomInfo(this.props.widgetDto.widgetId)
            ?.selectedMentorId ??
          this.props.filteredSortedMentorsCtrlDtoValues[0].extendedMentorDto
            .mentorDto.mentorId;
        this.openCloseSpecificWidgetV2(selectedMentorId);
      } else {
        if (this.props.filteredSortedMentorsCtrlDtoValues?.length) {
          this.openCloseSpecificWidgetV2(
            this.props.filteredSortedMentorsCtrlDtoValues[0].extendedMentorDto
              .mentorDto.mentorId,
          );
        } else {
          const exMentorDto = Object.values(
            this.props.widgetDto.mentorsControlMapDto,
          )[0]?.extendedMentorDto;
          this.openCloseSpecificWidgetV2(exMentorDto?.mentorDto?.mentorId);
        }
      }
    }
  };

  handleMultiWidgetInit = () => {
    const ownerObjectId = this.props.inTeamChatScenario
      ? multiWidgetService.getWidgetTeamMentorIds(this.props.widgetDto)[0]
      : this.props.openSingleWidgetByPeerId;
    if (ownerObjectId) {
      this.openCloseSpecificWidgetV2(ownerObjectId);
    }
  };

  openCloseSpecificWidgetV2 = (ownerObjectId) => {
    if (this.props.isDemo) {
      if (this.props.demoOpenCloseWidget) {
        this.props.demoOpenCloseWidget();
      }
    } else {
      if (ownerObjectId) {
        /**
         * If widgetMode is singleExpert and max no.of widgets less than 0 then
         * hide the widget
         */
        // if (
        //   this.props.isMultiWidget &&
        //   this.props.widgetMode ===
        //     VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE &&
        //   this.props.shouldHideEntireWidget()
        // ) {
        //   this.props.resetOpenSingleWidgetByPeerIdAndActionClickData(() => {
        //     // Call this only when state in parent is reset
        //     this.props.closeMultiWidget();
        //   });
        // }
        // show this widget and hide all others
        // change iframe size to widget size

        const currentMentorId =
          this.state.selectedExMentorDto?.mentorDto?.mentorId;
        let newShowSingleWidget;
        let selectedExMentorDto;
        if (currentMentorId === ownerObjectId) {
          // Same mentor, toggle
          newShowSingleWidget = !this.state.showSingleWidget;
          selectedExMentorDto = newShowSingleWidget
            ? this.props.inTeamChatScenario
              ? this.props.widgetDto.teamMentorsMapDto[ownerObjectId]
                  .extendedMentorDto
              : this.props.widgetDto.mentorsControlMapDto[ownerObjectId]
                  .extendedMentorDto
            : null;
        } else {
          // Different mentor or opening
          newShowSingleWidget = true;
          selectedExMentorDto = this.props.inTeamChatScenario
            ? this.props.widgetDto.teamMentorsMapDto[ownerObjectId]
                .extendedMentorDto
            : this.props.widgetDto.mentorsControlMapDto[ownerObjectId]
                .extendedMentorDto;
        }
        /**
         * Commented below if block: As per flow from Diagram
         */
        // if (
        //   (this.props.isSingleWidget || this.props.isMultiWidget) &&
        //   this.props.openSingleWidgetByPeerId &&
        //   this.state.showSingleWidget
        // ) {
        //   // // Reset peer id in parent and action click data
        //   // this.props.closeMultiWidget();
        //   this.props.resetOpenSingleWidgetByPeerIdAndActionClickData(() => {});
        // }
        this.setState(
          {
            selectedExMentorDto: newShowSingleWidget
              ? selectedExMentorDto
              : null,
            showSingleWidget: newShowSingleWidget,
          },
          () => {
            // If single expert widget is visible then change Widget mode
            if (newShowSingleWidget) {
              this.props.setWidgetMode(
                VIDABOO_CONSTANTS.WIDGET_MODES.SINGLE_EXPERT_MODE,
              );
            } else {
              // todo 1720 : verify this, as incoming if block was directly accepted while resolving conflicts. So we might need conditions from commentted if block
              // if (
              //   this.props.isSingleWidget ||
              //   (this.props.inTeamChatScenario &&
              //     this.props.widgetDto.widgetAppCtrlDto
              //       .widgetInteractionMode !==
              //       VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT) ||
              //   isHeaderCloseBtnClicked
              // )
              if (this.props.isSingleWidget || this.props.isTeamChat) {
                this.props.setWidgetMode(
                  VIDABOO_CONSTANTS.WIDGET_MODES.MASK_MODE,
                );
              } else {
                this.props.setWidgetMode(
                  VIDABOO_CONSTANTS.WIDGET_MODES.ACCOUNT_MODE,
                );
              }
            }

            // Change iframe size only when state is updated.
            let newSize = VIDABOO_CONSTANTS.WIDGET_SIZE.ACCOUNT_WIDGET_OPEN;
            let postMsgData;
            if (newShowSingleWidget) {
              newSize = VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN;
              if (
                selectedExMentorDto &&
                selectedExMentorDto.mentorDto.appControlDto.widgetActionSelector
              ) {
                const actionClickData = this.props.actionClickData;
                const adjustHeightByActionSelector =
                  !actionClickData ||
                  (actionClickData &&
                    (actionClickData.etClickType === 'open-widget' ||
                      actionClickData.etConsoltoStart ===
                        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.OPEN_WIDGET) &&
                    actionClickData.etAgentId !== 'multi') ||
                  (actionClickData.clientInfo &&
                    actionClickData.cFirstName &&
                    actionClickData.cEmail);
                if (adjustHeightByActionSelector) {
                  const actionSelectorHeaderText =
                    selectedExMentorDto.mentorDto.appControlDto
                      .widgetEditableTexts &&
                    selectedExMentorDto.mentorDto.appControlDto
                      .widgetEditableTexts[
                      VIDABOO_CONSTANTS.WIDGET_APP_HEADER_TITLE_TYPES
                        .ACTION_SELECTOR
                    ];
                  postMsgData = {
                    foregroundWidgetsLength:
                      selectedExMentorDto.mentorDto.appControlDto
                        .foregroundWidgets.length,
                    actionSelectorHeaderText,
                  };
                  newSize = VIDABOO_CONSTANTS.WIDGET_SIZE.ACTION_SELECTOR;
                }
              }
            } else if (
              this.props.isSingleWidget ||
              (this.props.inTeamChatScenario &&
                this.props.widgetDto.widgetAppCtrlDto.widgetInteractionMode !==
                  VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT)
            ) {
              newSize = VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED;
            }

            this.props.changeIframeSize(
              newSize,
              'multiWidget',
              null,
              postMsgData,
            );
            this.props.setSingleWidgetMentorId(
              newShowSingleWidget
                ? selectedExMentorDto?.mentorDto?.mentorId
                : null,
            );
            this.props.setIsSingleWidgetMounted(newShowSingleWidget);
          },
        );
      } else {
        console.error(
          'Consolto Widget: tried to open mentor with a wrong mentorId. Please make sure you provided the right mentorId and mentor is active.',
        );
      }
    }
  };

  closeMultiWidget = () => {
    this.props.setLastMWClose(true);
    // reset openCloseSpecificWidgetByPeerUserId and actionClickData
    this.props.resetOpenSingleWidgetByPeerIdAndActionClickData(() => {
      // Call this only when state in parent is reset
      this.props.closeMultiWidget();
    });
  };

  createDagMessageData = (
    isWidgetOpened,
    connectionContextOwnerId,
    connectionContextOwnerType,
  ) => {
    // MULTIDAG activity below:
    let dagMsgData = {
      SubType: VIDABOO_CONSTANTS.DAG_SUBTYPES.WIDGET_OPEN_STATE,
      // senderProfileName: this.context.getCurrentUser().userId,
      senderUserId: this.context.getCurrentUser().userId,
      connectionContextOwnerType,
      connectionContextOwnerId,
      message: isWidgetOpened
        ? VIDABOO_CONSTANTS.ENDPOINT_WIDGET_OPEN_STATES.WIDGET_OPEN
        : VIDABOO_CONSTANTS.ENDPOINT_WIDGET_OPEN_STATES.WIDGET_CLOSED,
      senderCreationTime: new Date().getTime(),
      sessionStartTime: new Date().getTime(),
      isMobileDevice: utilsService.isMobileDevice(), //todomcss : ok
      currentPage: this.props.getPageLocation(),
    };
    dagMsgData.mountedConnectionContextOwnerId = isWidgetOpened
      ? this.state.selectedExMentorDto.mentorDto.mentorId
      : null;
    return dagMsgData;
  };

  sendWidgetOpenCloseStatus = (/* isWidgetOpened */) => {
    return;
    // part of multiDag features: send status of widget (open or closed).
    // if (
    //   this.props.widgetDto.widgetAppCtrlDto.isAqIndicationsEnabled &&
    //   !this.props.isDemo
    // ) {
    //   Object.values(this.props.widgetDto.mentorsControlMapDto).forEach(
    //     (widgetMentorCtrlDto) => {
    //       if (!widgetMentorCtrlDto.disableAqIndications) {
    //         this.sendWidgetOpenClosedState(
    //           widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId,
    //           widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId,
    //           this.props.inTeamChatScenario
    //             ? VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
    //             : VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR,
    //           isWidgetOpened,
    //         );
    //       }
    //     },
    //   );
    // }
  };
  sendWidgetOpenClosedState = (
    peerUserId,
    mentorId, // connectionContextOwnerId
    mentorType, // connectionContextMentorType
    isWidgetOpened,
  ) => {
    const widgetMsgObj = this.createDagMessageData(
      isWidgetOpened,
      mentorId,
      mentorType,
    );
    ListeningRoomService.publishToListeningRoom(
      widgetMsgObj,
      this.context.getCurrentUser().userId,
      peerUserId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );
  };
  openCloseWidget = () => {
    if (this.props.isSingleWidget) {
      this.props.setLastMWClose(true);
    }
    const ownerObjectId = this.state.selectedExMentorDto.mentorDto.mentorId;
    this.openCloseSpecificWidgetV2(ownerObjectId);
  };

  render() {
    const {
      isMultiWidget,
      inTeamChatScenario,
      widgetDto,
      handleTransitionToTeamChatRoom,
      openWidgetByTabType,
    } = this.props;

    return (
      <>
        {widgetDto && (
          <div
            className={
              'et-accounts-open-widget-wrap' +
              (this.state.showSingleWidget || inTeamChatScenario
                ? ' et-accounts-open-single-widget-open'
                : '') +
              (this.state.removeAgentListFadeAnim
                ? ' et-accounts-remove-magazine-section-fade-anim'
                : '')
            }>
            {this.props.widgetMode ===
            VIDABOO_CONSTANTS.WIDGET_MODES.DIRECTORY ? (
              <>
                {this.props.filteredSortedMentorsCtrlDtoValues?.length > 0 &&
                  !this.props.isEntireWidgetHidden && (
                    <MentorsDirectoryComponent
                      filteredSortedMentorsCtrlDtoValues={
                        this.props.filteredSortedMentorsCtrlDtoValues
                      }
                    />
                  )}
              </>
            ) : !this.state.showSingleWidget && !inTeamChatScenario ? (
              !this.props.openSingleWidgetByPeerId &&
              this.props.filteredSortedMentorsCtrlDtoValues.length > 0 && (
                <MultiExpertAgentsListWithHeaderComponent
                  filteredSortedMentorsCtrlDtoValues={
                    this.props.filteredSortedMentorsCtrlDtoValues
                  }
                  isDemo={this.props.isDemo}
                  widgetDto={widgetDto}
                  closeMultiWidget={this.closeMultiWidget}
                  handleTransitionToTeamChatRoom={
                    handleTransitionToTeamChatRoom
                  }
                  openCloseSpecificWidgetV2={this.openCloseSpecificWidgetV2}
                  openWidgetByTabType={openWidgetByTabType}
                />
              )
            ) : (
              this.state.selectedExMentorDto && (
                <SingleExpertWidget
                  key={this.state.selectedExMentorDto.mentorDto.mentorId}
                  canMoveToTeamChat={this.props.canMoveToTeamChat}
                  isDemo={this.props.isDemo}
                  isEntireWidgetHidden={this.props.isEntireWidgetHidden}
                  isMultiWidget={isMultiWidget}
                  inTeamChatScenario={inTeamChatScenario}
                  widgetDto={widgetDto}
                  extendedMentorDto={this.state.selectedExMentorDto}
                  isInAccount={!utilsService.getIsPersonalPage()} //TODOBR: discuss with Ilan
                  openCloseWidget={this.openCloseWidget}
                  startChatWithPeerId={this.props.openSingleWidgetByPeerId}
                  actionClickData={this.props.actionClickData}
                  doWhenActionClick={this.props.doWhenActionClick}
                  resetActionClickData={this.props.resetActionClickData}
                  dispatchConsoltoEvents={this.props.dispatchConsoltoEvents}
                  startValueFromQuery={this.props.startValueFromQuery}
                  bfi={this.props.bfi}
                  isAutomatedCallHandled={this.props.isAutomatedCallHandled}
                  setIsAutomatedCallHandled={
                    this.props.setIsAutomatedCallHandled
                  }
                  onHeaderBackButton={() => {
                    // canMoveToTeamChat true means back btn was click in one-on-one chat and team chat needs to be loaded now
                    if (!this.props.canMoveToTeamChat) {
                      this.openCloseWidget();
                    }
                    this.props.onHeaderBackButton();
                  }}
                  onHeaderCloseButton={() => {
                    this.setState({showSingleWidget: false});
                    this.props.onHeaderCloseButton();
                  }}
                />
              )
            )}
          </div>
        )}
      </>
    );
  }
}
OpenMultiWidgetComponent.contextType = AppContext;
export default withWidgetContext(OpenMultiWidgetComponent);
